// Common code shared by both client and server
// to make the code accessible type :
//  $ cd client
//  $ npm link ../ppe-business --save
//  $ cd ../server
//  $ npm link ../ppe-business --save
// These lines also have to be typed on the server

const resources = require("./resources")
const version   = require("./version.json")
const DU        = require('./du/du-core.js')

const DUCatalog = require('./du/catalog.js')

module.exports = { 
    // Exported settings
    ClientVersion : version.current, //'1.2.9',
    sendEmails    : process.env.NODE_ENV === 'production', // Default value to send actual emails (can be deactivated in the Admin/Settings)
    sendEmailsToPeople : process.env.NODE_ENV === 'production',
    baseApiURL :    process.env.NODE_ENV === 'production'? 'https://api.prevention-risquespro.fr':"http://localhost:4000",
    baseClientURL : process.env.NODE_ENV === 'production'? 'https://ppe.prevention-risquespro.fr':"http://localhost:3002",
    DU,
    DUCatalog : DUCatalog.load(),

    // set cacheInterface to set getResource() from a cache manager
    cacheInterface: {getResource:(resourceId, defaultTo)=>undefined},

    R: function (resourceId, defaultTo, parameters, editMode) {
        //console.log("module.exports.cacheInterface", module.exports.cacheInterface)
        let v = firstDefined( [
            module.exports.cacheInterface.getResource(resourceId, defaultTo),
            resources.strings[resourceId],
            defaultTo,
            "strings." + resourceId])

        //console.info("ppe-business:R():defaultTo", v)
        // Remove extra \ at the end of the lines
        v = v.replace(/\\\r\n/gm, "\n")
        if(parameters && !editMode) {
            console.log("R.PARAMETERS", parameters)
            for(let p in parameters) {
                v = v.replace(new RegExp(p, 'gm'), parameters[p])
            }
        }
        return v
    },

    resources : resources,

    VISIBILITY : {
        visible:  'visible',
        hidden:   'hidden',
        archived: 'archived',
    },
  
    STATUS : {
        valid:      'valid',
        doing:      'doing',
        draft:      'draft',
        received:   'received',
        done:       'done',
    },

    INVITE_STATUS : {
        draft:    'draft',
        sent:     'sent',
        resent:   'resent',
    },
  
    OPERATION : {
        access:         'access',       // ACCES 
        delivery:       'delivery',     // Livraison
        prescription:   'prescription', // INTERVENTION Prescription 
        maintenance:    'maintenance',  // INTERVENTION Maintenance
        improvement:    'improvement',  // TACHES d'Amélioration
        work:           'work',         // TRAVAUX sous PGC   
    },
  
    GROUP : {
        USER:'USER', // Utilisateur
        MANAGER:'MANAGER', // Gestionnaire
        PARTNER:'PARTNER', // Partenaire
        ADMIN:'ADMIN',
    },

    SEVERITY_ERROR : {
        LOW:        1,
        MEDIUM:     2,
        HIGH:       3,
        CRITICAL:   4
    },
    
    getGroupOptions() {
        let ret = {}
        for(let o in this.GROUP)
            ret[o] = this.getGroupLabel(o)
    
        //console.log("getGroupOptions()", ret)
        return ret
    },

    // return only supported operations
    getOPERATIONList(filterAdminOperation) {
        if(filterAdminOperation)
        return [
            this.OPERATION.maintenance,
            this.OPERATION.improvement,
            this.OPERATION.work
            ] 
        else
        return [
            this.OPERATION.access, 
            this.OPERATION.delivery,
            this.OPERATION.prescription,
            this.OPERATION.maintenance,
            this.OPERATION.improvement,
            this.OPERATION.work
            ] 
    
    }, 
      
  
    getOperationLabel(op) {
        switch(op) {
            /*
            "Accès": | ACCES Livraisons; I ACCES
            "Livraison": | ACCES Livraisons; I LIVRAISONS
            "Intervention": | INTERVENTION Prescription I INTERVENTION
            "Tâches": | TACHES d'Amélioration. I TACHES
            "Travaux": | TRAVAUX sous PGC I TRAVAUX
            */
            case this.OPERATION.access:         return "ACCES";
            case this.OPERATION.delivery:       return "LIVRAISONS";
            case this.OPERATION.prescription:   return "INTERVENTION";
            case this.OPERATION.maintenance:    return "Aménagement & Travaux (PPE1)"; // ex: MAINTENANCE
            case this.OPERATION.improvement:    return "Support & Maintenance (PPE2)"; // ex: TACHES
            case this.OPERATION.work:           return "Evènement (PPE3)";             // ex: TRAVAUX
        }
        throw new Error(`Unkonwn operation label for '${op}'`)
    },
  
    getGroupLabel(op) {
        switch(op) {
            case this.GROUP.USER:     return "Utilisateur";
            case this.GROUP.ADMIN:    return "Administrateur";
            case this.GROUP.MANAGER:  return "Gestionnaire PPE";
            case this.GROUP.PARTNER:  return "Partenaire APR 2SP";
        }
        throw new Error(`Unkonwn group label for '${op}'`)
    },

    getOperationsOptions(filterAdminOperation) {
        let ret = {}
        for(let o of this.getOPERATIONList(filterAdminOperation))
            ret[o] = this.getOperationLabel(o)
    
        //console.log("getOperationsOptions()", ret)
        return ret
    },
  
    getStatusClass(st) { 
        switch(st) {
            case this.STATUS.valid :    return 'success' 
            case this.STATUS.doing :    return 'warning' 
            case this.STATUS.draft :    return 'danger' 
            case this.STATUS.received : return 'info' 
            case this.STATUS.done :     return 'primary' 
        }
        return ''
    },

    getStatusLabel(st) { 
        switch(st) {
            case this.STATUS.valid :    return 'Valide' 
            case this.STATUS.doing :    return 'En cours' 
            case this.STATUS.draft :    return 'Brouillon' 
            case this.STATUS.received : return 'Soumis' 
            case this.STATUS.done :     return 'Terminé' 
        }
        return ''
    },

    toDate(apiDate) { 
      if(!apiDate) return ''
      let date = new Date(apiDate)
      return date ? date.toShortFormat() : '?'
    },

    toDateTime(apiDate) { 
        //Intl.DateTimeFormat

        let date = new Date(apiDate)

        const localDateString = date.toLocaleDateString('fr-FR', {  
            day:   'numeric',
            month: 'short',
            year:  'numeric',
        });
        
        
        const localTimeString = date.toLocaleTimeString('fr-FR', {
            hour:   '2-digit',
            minute: '2-digit',
            second: '2-digit',
        })


        return localDateString + " " + localTimeString
      },
  
  
    COMMONMETHODS : {
        toDate : this.toDate
    },
  
  
    canDisplayOperations(accountStatus, companyStatus) {
        if(accountStatus === this.STATUS.draft) return false;
        if(companyStatus === this.STATUS.draft) return false;
        return true; 
    },
  
    checkboxCheckedChar : '▩', //'▩', // ☑, ✅, 
    checkboxUncheckedChar: '☐',
  
    reccurrentDangers : [ 
      {value:'rd37', label:"Alcool， psychotropes", suffixValues:["Présence d’alcool et psychotropes， risques d’accidents","Interdire l’alcool et les psychotropes sur les lieux de travail， mise en place de procédure de contrôle"] }, 
      {value:'rd38', label:"Ambiance atmosphérique", suffixValues:["Présence de fumée， vapeurs， aérosols…","Port des EPI (masque， lunettes， gants)， interdiction de fumer， aérer le local"] }, 
      {value:'rd39', label:"Ambiance lumineuse", suffixValues:["Manque de lumière， éclairage intensif， zone d’éblouissement， contraste du niveau d’éclairement","Utiliser un éclairage d’appoint， lampe frontale， sensibiliser aux risques d’éblouissement et altération de la vision， s’assurer que l’installation évitera les effets thermiques et les risques de brûlures"] }, 
      {value:'rd40', label:"Ambiance sonore， bruit", suffixValues:["Environnement de travail bruyant， outillage électroportatif","Port de protection auditives individuelles au-dessus de 400dB: casque anti-bruit ， bouchons d’oreilles， signaliser les zones à forte exposition sonore"] }, 
      {value:'rd41', label:"Chimie – Produits dangereux", suffixValues:["Brûlures， projections， intoxications， utilisation de solvants， acide， gaz， colle， aérosols， essence…","Afficher les consignes d’utilisation des produits chimiques dans les lieux dédiés， conserver les produits dans leur emballage. Port des EPI (gants， lunettes， masque， tenue…) - Posséder les FDS - Ventiler le local"] }, 
      {value:'rd42', label:"Chute de hauteur", suffixValues:["Travail en hauteur","Port des EPI， port du harnais， autorisation employeur， balisage de la zone de travaux， personnel formé aux travaux en hauteur"] }, 
      {value:'rd43', label:"Chute de plain-pied", suffixValues:["Sol glissant， irrégulier， caniveau， faux-plancher， présence de tranché…","Utiliser les voies piétonnes， ranger， baliser， assurer un éclairage adapté， mise en place de goulottes sur les connecteurs mobiles， adapter les chaussures à l’activité et aux contraintes du sol"] }, 
      {value:'rd44', label:"Chute d’objet", suffixValues:["Chute de matériel ou de matériaux","Baliser la zone de travail， port des EPI (casque…)， organiser le stockage， interdire l’accès pendant les opérations de levage et de manutention mécanique"] }, 
      {value:'rd45', label:"Co activité", suffixValues:["Intervention à proximité d’une Entreprise Extérieure. Intervention du personnel de l’Entreprise Utilisatrice","Assurer la coordination dans le temps et dans l’espace des travaux， baliser la zone de travail， communiquer entre personnes sur les tâches à accomplir， accueil spécifique des intervenants pour préciser les risques spécifiques lors de la VIP"] }, 
      {value:'rd46', label:"Conditions climatiques", suffixValues:["Conditions climatiques extrêmes， forte chaleur en été， pluie， neige， vent， foudre， température hivernale","Organiser le temps de travail， droit de retrait， bonne hydratation， pauses régulières en milieu tempéré， port de vêtements chauds， mettre à disposition eau fraîche ou boissons chaudes"] }, 
      {value:'rd47', label:"Contact avec le public", suffixValues:["altercations verbales， agressions physiques， comportements violents lors d’événements","Respect du public et du livret d’Accueil Prévention， sensibilisation/ formation sur l’attitude à adopter en cas d’incivilité， d’agressivité ou de violences"] }, 
      {value:'rd48', label:"Contamination Biologique", suffixValues:["Intoxications， contaminations dus aux contacts avec les personnes","Lavage des mains avec savon ou produit hydro alcoolique， port de gants， respect des mesures d’hygiènes， afficher les protocoles AES"] }, 
      {value:'rd49', label:"Coupure， blessure", suffixValues:["Tôle tranchante， bord tranchant， outillage défectueux， outils coupants","Porter des gants anti-coupure et les protections adaptées aux outillages utilisés， utiliser des cutters à lame rétractable"] }, 
      {value:'rd50', label:"Déchargement de véhicule", suffixValues:["Ecrasement， TMS","Respect des règles en vigueur sur le site， respect du Protocole de Sécurité， du plan de circulation， de la limitation de vitesse"] }, 
      {value:'rd51', label:"Déplacement de charges suspendues", suffixValues:["Utilisation de potence","Porter des EPI， balisage de la zone de travaux， outillage conforme"] }, 
      {value:'rd52', label:"Déplacement routier sur site", suffixValues:["Ecrasement， collision， obstacles， renversement","Respecter les voies de circulation， respect des règles de signalisation du site， priorité aux piétons"] }, 
      {value:'rd53', label:"Electricité", suffixValues:["Electrisation， électrocution， incendie， projection de particules， absence de plan des circuits， matériel défectueux， retour de courant","Porter des EPI électriques， être habilité， baliser la zone de travail， interdire l’accès aux personnes non habilitées， identifier les zones sous tension， consignation， outillage isolé， programmation des travaux， utiliser des prolongateurs équipés de connecteurs étanches，"] }, 
      {value:'rd54', label:"Eau souillée", suffixValues:["Intoxication， tuyauterie bouchée ou défectueuse","Lavage des mains， vaccination à jour， port de gants， de masque…"] }, 
      {value:'rd55', label:"Fluide", suffixValues:["Intoxication, asphyxie， explosion， inondation， ","Consignation avant travaux， identification du fluide， aération du local， présence d’extincteur"] }, 
      {value:'rd56', label:"Incendie", suffixValues:["Matériel carburant défectueux， source de chaleur， solvant， étincelle， cendres， fumigènes， pyrotechnie","Posséder un extincteur vérifié， respect des consignes de stockage et d’utilisation des solvants， détenir un permis feu， respecter l’interdiction de fumer， formaliser le descriptif technique et les conditions d’exécution matérielle en précisant les mesures de prévention"] }, 
      {value:'rd57', label:"Manutention manuelle", suffixValues:["Port de charges， accès difficiles， douleurs dorsales， chute de plain-pied","Utiliser un moyen d’aide à la manutention， port de gants et de chaussures de sécurité， rangement de la zone de travail et de circulation， adopter gestes et postures appropriées， écrire et respecter les procédures à chaque manipulation spécifique"] }, 
      {value:'rd58', label:"Manutention mécanique", suffixValues:["Travaux sous ou à proximité d’une charge en cours de manutention (grue， chariot， transpalette…)","Vérifier les moyens de manutention， documents de l’engin， gérer la coactivité， baliser les zones de manutention， respecter la vitesse autorisée， utiliser avertisseurs lumineux et sonores"] }, 
      {value:'rd59', label:"Nacelle", suffixValues:["Chute d’objet， chute de personne， renversement de la nacelle， collision","Baliser la zone de travail， port des EPI CACES， autorisation employeur， document nacelle， port du harnais"] }, 
      {value:'rd60', label:"Outillage électroportatif", suffixValues:["Electrisation， projection de particules， nuisances sonores， coupures， brûlures， vibrations","Port des EPI， vérification du matériel avant et après utilisation， un permis feu doit être délivré pour tous travaux par points chauds"] }, 
      {value:'rd61', label:"Ouverture dans le sol", suffixValues:["Creusement de tranchée， chute de hauteur， chute d’objet， accès difficile","Balisage de la zone de travaux， port des EPI"] }, 
      {value:'rd62', label:"Passage de personnel", suffixValues:["Contact avec le personnel， chute de plain-pied","Respect du chemin de circulation， port du gilet jaune"] }, 
      {value:'rd63', label:"Personnel intérimaire / Contractuel", suffixValues:["Méconnaissance des risques au poste de travail","Visiter les lieux avec le préventeur dédié et informer des consignes de sécurité"] }, 
      {value:'rd64', label:"Pièces en mouvement", suffixValues:["Ecrasement， coupures， heurts","Port des EPI， interdiction de travailler à proximité sans autorisation， consignation avant intervention"] }, 
      {value:'rd65', label:"Risques psychosociaux", suffixValues:["Stress， burn out","Communication au sein de l’entreprise sur les objectifs et les priorités， faciliter le dialogue entre les intervenants， désigner si besoin un médiateur"] }, 
      {value:'rd66', label:"Sûreté malveillance", suffixValues:["Vols， dégradation du site","Filtrage et respect des conditions d’accès au site"] }, 
      {value:'rd67', label:"Superposition d’activités", suffixValues:["Chute d’objet， chute de personnes， chute de plain-pied","Balisage de la zone de travail， port des EPI"] }, 
      {value:'rd68', label:"Travail isolé", suffixValues:["Isolement géographique， hors de vue， hors de portée de voix， dû aux bruits， aux horaires…","Définir les moyens de communication， respecter les instructions sur le travail isolé， organiser un mode de surveillance， fournir un PTI ou un DATI"] }, 
      {value:'rd69', label:"Travail sur toiture", suffixValues:["Chute de hauteur， chute d’objet","Baliser la zone de travail au sol， port du harnais， outillage équipé d’une dragonne， port des EPI"] }, 
      {value:'rd70', label:"Travail en TST", suffixValues:["Electrocution， projection de particules","Port des EPI électriques， habilitation TST， outillage spécifique TST， présence des documents obligatoires"] }, 
      {value:'rd71', label:"Travail à la corde", suffixValues:["Chute de hauteur， chute d’objet","Port des EPI， port du harnais， autorisation employeur， balisage de la zone de travaux， personnel formé"] }, 
      {value:'rd72', label:"Travaux de grutage", suffixValues:["Ecrasement， chute d’objet， collision","Baliser la zone de travail， port des EPI, détention du CACES， autorisation employeur， document nacelle， port du harnais"] }, 
      {value:'rd73', label:"Travaux de bureautique", suffixValues:["TMS， chute de plain-pied， déficience visuelle， coupure","Suivi des personnes"] }, 
      {value:'rd74', label:"Travaux sur échelle， sur escabeau", suffixValues:["Chute de hauteur， chute de plain-pied， chute d’objet","Mise en place d’un mode opératoire， balisage de la zone de travail， port des EPI (casque， chaussures)， ne pas utiliser d’échelle comme poste de travail sauf pour une intervention de courte durée, mais comme un moyen d'accès"] }, 
      {value:'rd75', label:"Exposition aux rayonnements ionisants en zone réglementée", suffixValues:["irradiation potentielle par générateur électrique de rayons X en Radiologie et en Médecine nucléaire","Plan de Prévention Radioprotection Imagerie et Postes Déportés ou Plan de Prévention Radioprotection Medecine Nucléaire à renseigner et nous renvoyer par email"] }, 
      {value:'rd76', label:"Travaux en milieu confiné， fosse， cuve， réservoir", suffixValues:["Asphyxie， intoxication， chute de hauteur， chute d'objets","Autorisation employeur， travaux en binôme， éclairage d’appoint， respect des règles d'hygiène， port des EPI"] }, 
      {value:'rd77', label:"Travaux par point chaud", suffixValues:["Brûlures， incendie， produits inflammables","Permis de feu， extincteur， écran inifuge"] }, 
      {value:'rd78', label:"Utilisation d’échafaudage", suffixValues:["Chute de hauteur， chute d’objet， chute de plain-pied","Baliser la zone de travail， port des EPI (casque， chaussures)， personnel formé au montage et démontage d’un échafaudage"] }, 
      {value:'rd79', label:"Utilisation d’un appareil à rayon laser", suffixValues:["Déficience visuelle","Port des EPI， balisage de la zone de travaux， sensibilisation des salariés aux dansgers liés aux faisceaux lumineux"] }, 
      {value:'rd80', label:"Utilisation d’un appareil de levage", suffixValues:["Utilisation de treuil， palan， vérin","Sensibilisation des salariés aux dangers liés aux faisceaux lumineux， balisage de la zone d’intervention， port des EPI"] }, 
      {value:'rd81', label:"Zone ATEX", suffixValues:["Explosion","Formation du personnel， outillage spécifique， mise en place d’un mode opératoire avant travaux， baliser la zone de travaux"] }, 
      {value:'rd82', label:"Zone Ordures Ménagères", suffixValues:["Chute de plain-pied， risque biologique， coupure","Port des EPI， baliser la zone de travaux， respect des règlesd’hygiène， séparer les différentes catégories de déchets"] }, 
  
      ],
  
      preInterventionProcedures : {
          pi1:"Consignation / déconsignation Electrique; Ne jamais toucher à un câble au sol, au risque de s'exposer à une conséquence grave",
          pi2:"Consignation / déconsignation Hydraulique",
          pi3:"Consignation / déconsignation Mécanique",
          //pi4:"Habilitation électrique (niveau requis); B0 – H0 - H0V intervenant non électricien; B1 – H1 - B1V – H1V intervenant électricien",
          //pi5:"Présence d'un surveillant qualifié (travaux électriques); B2 –H2 - B2V – H2V chargé de travaux; BC HC chargé de consignation",
          //pi6:"BR : chargé d’intervention dépannage",
          },
  
      specificAuthorizations : {
          sa0:"Pour tronçonner, meuler, souder (permis feu)...",
          sa1:"Pour entreposer les déchets",
          sa2:"Pour neutraliser les dispositifs de détection incendie",
          sa3:"Pour neutraliser l’extinction automatique contre l’incendie",
          sa4:"Pour mettre à disposition matériels ou engins (rédiger contrat ou attestation de prêt)",
          sa5:"Pour utiliser des pistolets de scellement",
          sa6:"Pour pénétrer en espace confiné",
          sa7:"Pour employer un travailleur isolé",
          sa8:"Pour réaliser des travaux en hauteur",
          sa9:"Pour stocker du matériel en container",
          sa10:"Pour Charger / décharger",
      },

      specialAuthorisations:{
        sp1:"Permis feu",
        sp2:"Permis pour travaux en hauteur",
        sp3:"Protocole de Sécurité pour décharger / charger",
      },
  
      covidDangers : [ 
          {value:'cd37', label:"Contamination biologique par projection， contact", suffixValues:["Infection biologique au coronavirus des personnes", "Respecter une distance minimale de 37m， laver fréquemment avec soin ses mains à l'eau et au savon， ou à défaut au gel hydroalcolique et utiliser des essuies-mains à usage unique. Le port du masque est obligatoire à l'intérieur des lieux où des patients sont accueillis， ainsi que pour les personnes identifiées comme cas contact. Le port du masque n'est plus obligatoire dans les lieux n'accueillant pas de patients， mais reste recommandé et à l'appréciation de chacun."] }, 
          {value:'cd38', label:"Contamination des objets", suffixValues:["Infection des équipements et des outillages", "Nettoyer avec un produit désinfectant les outils， les équipements， plans ou poste de travail des personnels"] },
          {value:'cd39', label:"Contamination des locaux", suffixValues:["Infection des personnes par contact","passer 1 fois par jour un désinfectant， à l’eau de JAVEL diluée， dans les cantonnements et locaux sanitaires"] }, 
      ],
  
  
  
      sourceOfDangers : [
          {name:"electric",    label:"ÉLECTRIQUE",  type: "checkboxtable",     size: 'medium', options:[
              {value:'el1', label: "Proximité d’armoires électriques 2",},
              {value:'el2', label: "Proximité lignes aériennes électriques",},
              {value:'el3', label: "Appareillage en essai sous tension",},
              {value:'el4', label: "Installations provisoires",},
              {value:'el5', label: "Présence HT à proximité",},
              {value:'el6', label: "Enceinte exiguë",},
              {value:'el7', label: "Parois métalliques ou conductrices",},
              {value:'el8', label: "Intervention en milieu humide",},
          ]},
          {name:"mecanic",    label:"MÉCANIQUE",  type: "checkboxtable",     size: 'medium', options:[
              {value:'me1', label: "Eléments sous contrainte (structure, câbles)",},
              {value:'me2', label: "Fluides sous pression hydraulique",},
              {value:'me3', label: "Equipement en charge",},
              {value:'me4', label: "Machine ou banc d’essais en fonctionnement",},
          ]},
          // {component:"div", size:"medium"},
  
          {name:"chimic",    label:"CHIMIQUE",  	type: "checkboxtable",     size: 'medium', options:[
              {value:'ch1', label: "Stockage de produits dangereux",},
              {value:'ch2', label: "Présence de gaz/vapeurs toxiques",},
              {value:'ch3', label: "Présence de gaz asphyxiant",},
              {value:'ch4', label: "Appareillage en essai",},
          ]},
           
          {name:"thermic",    label:"THERMIQUE",  	type: "checkboxtable",     size: 'medium', options:[
              {value:'th1', label: "Paroi chaude accessible",},
              {value:'th2', label: "Paroi froide accessible",},
          ]},
  
          //  {component:"div", size:"medium"},
  
          {name:"fire",    label:"INCENDIE/EXPLOSION",  	type: "checkboxtable",     size: 'medium', options:[
              {value:'fr1', label: "Présence de liquides inflammables ",},
              {value:'fr2', label: "Présence de matériaux combustibles ",},
              {value:'fr3', label: "Présence de gaz/vapeurs inflammables",},
              {value:'fr4', label: "Présence de produits comburants ",},
              {value:'fr5', label: "Présence de produits chimiques à réaction exothermique ",},
              {value:'fr6', label: "Atmosphère à risque d’explosivité ",},
              {value:'fr7', label: "Utilisation d’appareils provoquant des étincelles ",},
          ]},
  
          {name:"ionizingRadiation",    label:"RAYONNEMENTS IONISANTS",  	type: "checkboxtable",     size: 'medium', options:[
              {value:'ir1', label: "Appareils de radiographie en fonctionnement ",},
              {value:'ir2', label: "Stockage de source(s) de rayonnements ionisants ",},
          ]},
  
          //  {component:"div", size:"medium"},
          {name:"nonIonizingRadiation",    label:"RAYONNEMENTS NON IONISANTS",  	type: "checkboxtable",     size: 'medium', options:[
              {value:'nr1', label: "Laser en fonctionnement ",},
              {value:'nr2', label: "Pointeurs Laser P2 ",},
              {value:'nr3', label: "Générateurs électriques (scanner-accélérateur…) ",},
              {value:'nr4', label: "Générateurs de champs magnétiques et électrostatiques (IRM, antennes…) ",},
          ]},
  
          {name:"handlingCirculation",    label:"MANUTENTION CIRCULATION",  	type: "checkboxtable",     size: 'medium', options:[
              {value:'hc1', label: "Stockage de hauteur à proximité ",},
              {value:'hc2', label: "Transfert de charge en élévation par pont roulant, palan ",},
              {value:'hc3', label: "Circulation de chariots de manutention ",},
              {value:'hc4', label: "Circulation de véhicules ",},
          ]},
          
          //  {component:"div", size:"medium"},
           {name:"misc",    label:"DIVERS",  	type: "checkboxtable",     size: 'medium', options:[
              {value:'mc1', label: "Ambiance bruyante ",},
              {value:'mc2', label: "Espaces confinés (fosse, cuve, réservoir) ",},
              {value:'mc3', label: "Sol glissant ",},
              {value:'mc4', label: "Sol en excavation ",},
              {value:'mc5', label: "Toiture, planchers hauts en matériaux fragiles ",},
              {value:'mc6', label: "Proximité d’autres travaux  ",},
              {value:'mc7', label: "Locaux à risques infectieux ",},
              {value:'mc8', label: "Hélistation ",},
              {value:'mc9', label: "Travaux en superposition ",},
              {value:'mc10', label: "Chute d’amas de neige et de blocs de glace ",},
           ]},
      ],

      technicalCharacteristics : [ // CONNAISSANCE des CARACTERISTIQUES TECHNIQUES du SITE  à reporter sur le plan masse                 
        {value:'tc01', label:"1️⃣ lieux de chargement et de déchargement *"},
        {value:'tc02', label:"2️⃣ parkings d'attente"},
        {value:'tc03', label:"3️⃣ aires de bâchage ou de débâchage"},
        {value:'tc04', label:"4️⃣ plan de circulation /  limitations de vitesse"},
        {value:'tc05', label:"5️⃣ bureaux administratifs pour les documents"},
        {value:'tc06', label:"6️⃣ sanitaires (WC, lavabos, douches)"},
        {value:'tc07', label:"7️⃣ conteneurs à ordures"},
        {value:'tc08', label:"8️⃣ téléphones fixes"},
      ],

      forbiddenZones : {type:String}, // zones interdites aux chauffeurs
      
      fixedEquipment : [ // Equipement fixe 
        {value:'fx1', label:"plateforme élévatrice"},
      ],

      mobileEquipment : [ // Equipement mobile 
        {value:'mb1', label:"chariot élévateur"},
        {value:'mb2', label:"monte matériaux"},
        {value:'mb3', label:"transpalette électrique"},
        {value:'mb4', label:"transpalette à main"},
      ],

    manutentionMeans : [ // Moyens de manutention
        {value:'mm1', label:"grue auxiliaire"},
        {value:'mm2', label:"hayon élévateur"},
        {value:'mm3', label:"transpalette à main"},
        {value:'mm4', label:"diable"},
    ], 

    goodsConditions : [ // Etat des marchandises
        {value:'gc1', label:"Solide"},
        {value:'gc2', label:"Liquide"},
        {value:'gc3', label:"Gazeux"},
    ],

    goodsPackaging : [ // Conditionnement des marchandises
        {value:'gp1', label:"Vrac"},
        {value:'gp2', label:"Caisses"},
        {value:'gp3', label:"Palettes"},
        {value:'gp4', label:"Conteneurs"},
        {value:'gp5', label:"Citerne"},
    ],

    goodsOperation : [
        {value:'go1', label:"CHARGEMENT"},
        {value:'go2', label:"DECHARGEMENT"},
    ],

    risksLoadUnload : [ 
        {value:'ru1', label:"écrasement de personnes", 	suffixValues:["warning"] }, 
        {value:'ru2', label:"chute de personnes", 			suffixValues:["barriérage rigide"] }, 
        {value:'ru3', label:"chute d’objets", 					suffixValues:["balisage"] }, 
        {value:'ru4', label:"collision", 								suffixValues:["gyrophare / sirène"] }, 
        {value:'ru5', label:"co-activité verticale", 		suffixValues:["interdiction de travaux superposés"] }, 
        {value:'ru6', label:"électrisation", 						suffixValues:["usage de prolongateurs homologués"] }, 
        {value:'ru0', label:"Aucun risque (A cocher si vous ne cochez aucune autre) ", 	suffixValues:["aucun"] }, 
    ],

    VehicleLayout  : {'':'', 'VTC':'VTC', 'TAXI':'Taxi', 'VSL':'VSL', 'AMBULANCE':'Ambulance', 'ASSU':'ASSU', 'PLATEAU':'Plateau','BACHE':'Bâche','BENNE':'Benne','CITERNE':'Citerne','FRIGO':'Groupe Frigorifique'},
    VehicleType         : {'':'', VP:'Véhicule Privé', VTP:'Véhicule Transport de Personnes', VUL:'Véhicule Utilitaire Léger', VPL:'Véhicule Poid Lourd' },

      // Search for {{field.other.name}} and replace by data.field.other.name
    replaceFieldsInString(string, data) {
        const regex = /\{\{[\s]*(?<name>[\w\d.]+)[\s]*\}\}/gm;
        
        //console.log(`replaceFieldsInString `, string);
    
        let m;
        let replaced = string
        let i = 1
        while ((m = regex.exec(string)) !== null) {
            // This is necessary to avoid infinite loops with zero-width matches
            if (m.index === regex.lastIndex) {
                regex.lastIndex++;
            }
            
            // The result can be accessed through the `m`-variable.
            //console.log(`Found match `, m.groups);
            let fieldName = m.groups['name']
    
            var splitFieldName = fieldName.split('.')
            //var val = JSON.parse(JSON.stringify(data))
            var val = data
            for(var v of splitFieldName) {
                val = val ? val[v] : undefined
                if(val === undefined) break
            }
            if(typeof(val) === "object") {
                val = JSON.stringify(val)
            }
    
            if(val !== undefined) {
            // remove trailing and ending " in case the object was an Mongoose ObjectID("") that returns quoted string "q6s5dq6sd6q5s4dqs4d6q"
            val = val.replace(/^"+/, '').replace(/"+$/, '');

            // replace all occurrences of {{ field.name }} by val
            const replaceEx = new RegExp(`{{[\\s]*${fieldName}+[\\s]*}}`, 'gm')
            replaced = replaced.replace(replaceEx, val)
            }
    
            //console.log(`${i} - ${fieldName}=${val}`)
            i++
        }
        
        return replaced
    }
  
  }
  
  Date.prototype.toShortFormat = function() {
      let monthNames =["Jan","Fev","Mar","Avr",
                        "Mai","Jun","Jul","Aou",
                        "Sep", "Oct","Nov","Dec"];
        
        let day = this.getDate();
        
        let monthIndex = this.getMonth();
        let monthName = monthNames[monthIndex];
        
        let year = this.getFullYear();
        
        return `${day}-${monthName}-${year}`;
    }
    
function firstDefined(args) { 
    for(var v of args) 
        if(v!==undefined) return v
    
    return undefined
}
  
